import Immutable, { List } from 'immutable'

const participant = (state = null, action) => {
  switch (action.type) {
    case 'participant':
      return Immutable.fromJS(action.data)
    default:
      return state
  }
}

const participants = (state = new List(), action) => {
  switch (action.type) {
    case 'participants':
      return Immutable.fromJS(action.data)
    default:
      return state
  }
}

export { participant, participants }
